module.exports = __webpack_public_path__ + "eg.svg?b0aa9a4e893d49715b780350324cb985";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/eg.svg
// module id = 1338
// module chunks = 0